import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=493d00af&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493d00af')) {
      api.createRecord('493d00af', component.options)
    } else {
      api.reload('493d00af', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=493d00af&", function () {
      api.rerender('493d00af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4XOS6k05ZwtH7/JS/comp/childrenage.vue"
export default component.exports